import React from "react";

const EditClasses = () => {
  return <div>something</div>;
};

export default EditClasses;
